import { shouldEnableApiMocks } from "./config";

const shouldUseApiMocks = shouldEnableApiMocks(import.meta.env);

let apiMocksInitPromise: Promise<void> | undefined;

export async function ensureApiMocksInitialized(): Promise<void> {
  if (!shouldUseApiMocks) {
    return;
  }

  apiMocksInitPromise ??= import("./runtime").then(({ setupApiMocks }) => {
    setupApiMocks();
  });

  await apiMocksInitPromise;
}